var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PropsWrapper',{attrs:{"widgetProps":_vm.widgetProps,"has-datasource-tab":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }